const ListHeader = props => {
  const {
    leftText,
    rightComponent,
    rightText,
    containerClassName = "flex flex-col gap-4 border-b border-gray-200 px-4 py-4 sm:px-6 sm:py-5 md:flex-row md:items-center md:justify-between lg:px-8 lg:py-6",
    leftTextClassName = "mr-4 text-xl font-bold",
    rightTextClassName = "pl-4 text-xl font-bold text-black",
  } = props || {};

  const renderRightComponent = () => {
    if (!rightComponent) return null;
    if (typeof rightComponent === "function") {
      return rightComponent();
    }
    return rightComponent;
  };

  return (
    <div className={containerClassName}>
      <div className="flex min-w-0 flex-row flex-wrap items-center">
        <div className={leftTextClassName}>{leftText}</div>
        {rightText && (
          <>
            |
            <div className={rightTextClassName}>{rightText}</div>
          </>
        )}
      </div>
      {renderRightComponent()}
    </div>
  );
};

export default ListHeader;
